function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  @jsx h
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
var style = {
  "scrubber": "dhfc-1_0_0-beta_48-scrubber",
  "scrubber__bgBar": "dhfc-1_0_0-beta_48-scrubber__bgBar",
  "scrubber__bufferedBar": "dhfc-1_0_0-beta_48-scrubber__bufferedBar",
  "scrubber__playedBar": "dhfc-1_0_0-beta_48-scrubber__playedBar"
};

class Scrubber extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "bgElm", void 0);

    _defineProperty(this, "elm", void 0);

    _defineProperty(this, "handleElm", void 0);

    _defineProperty(this, "positionTimeout", void 0);

    _defineProperty(this, "state", {
      left: 0,
      width: 0,
      isScrubbing: false,
      position: null
    });

    _defineProperty(this, "handleKeyDown", evt => {
      const _this$props = this.props,
            duration = _this$props.duration,
            time = _this$props.time,
            onPositionUpdate = _this$props.onPositionUpdate;

      if (onPositionUpdate) {
        let nextTime = time;

        switch (evt.key) {
          case 'ArrowLeft':
            nextTime -= 1;
            break;

          case 'ArrowRight':
            nextTime += 1;
            break;
        }

        onPositionUpdate(Math.max(Math.min(nextTime / duration, 1), 0));
      }
    });

    _defineProperty(this, "handleMouseDown", evt => {
      evt.preventDefault();
      this.focus();
      this.start(evt.pageX);
      this.elm.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('mouseup', this.handleMouseUp);
    });

    _defineProperty(this, "handleMouseMove", evt => {
      this.move(evt.pageX);
    });

    _defineProperty(this, "handleMouseUp", evt => {
      this.focus();
      this.end();
      this.elm.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('mouseup', this.handleMouseUp);
    });

    _defineProperty(this, "handleResize", () => {
      const rect = this.bgElm.getBoundingClientRect();
      this.setState({
        left: Math.floor(rect.left),
        width: rect.width
      });
    });

    _defineProperty(this, "handleTouchStart", evt => {
      if (evt.touches.length === 1) {
        evt.preventDefault();
        this.focus();
        this.start(evt.touches[0].clientX);
        this.elm.addEventListener('touchmove', this.handleTouchMove);
        window.addEventListener('touchend', this.handleTouchEnd);
      }
    });

    _defineProperty(this, "handleTouchMove", evt => {
      if (evt.touches.length === 1) {
        this.move(evt.touches[0].clientX);
      }
    });

    _defineProperty(this, "handleTouchEnd", evt => {
      this.focus();
      this.end();
      this.elm.removeEventListener('touchmove', this.handleTouchMove);
      window.removeEventListener('touchend', this.handleTouchEnd);
    });
  }

  componentDidMount() {
    if (this.props.onPositionUpdate) {
      this.elm.addEventListener('keydown', this.handleKeyDown);
      this.elm.addEventListener('mousedown', this.handleMouseDown);
      this.elm.addEventListener('touchstart', this.handleTouchStart);
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }

  componentWillUnmount() {
    if (this.props.onPositionUpdate) {
      this.elm.removeEventListener('keydown', this.handleKeyDown);
      this.elm.removeEventListener('mousedown', this.handleMouseDown);
      this.elm.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('resize', this.handleResize);
    }
  }

  focus() {
    this.handleElm.focus();
  }

  start(clientX) {
    if (this.positionTimeout) {
      clearTimeout(this.positionTimeout);
    }

    this.setState({
      position: (clientX - this.state.left) / this.state.width,
      isScrubbing: true
    });
  }

  move(clientX) {
    this.setState({
      position: Math.max(Math.min((clientX - this.state.left) / this.state.width, 1), 0)
    });
  }

  end() {
    if (this.props.onPositionUpdate && this.state.position !== null) {
      this.props.onPositionUpdate(this.state.position);
    }

    this.setState({
      isScrubbing: false
    });
    this.positionTimeout = setTimeout(() => {
      this.setState({
        position: null
      });
    }, 350);
  }

  render() {
    const _this$props2 = this.props,
          duration = _this$props2.duration,
          time = _this$props2.time;
    const className = `${style.scrubber}${this.props.className ? ` ${this.props.className}` : ''}`;
    const position = this.state.position !== null ? this.state.position : time / duration;
    return h("div", {
      className: className,
      ref: elm => this.elm = elm
    }, h("div", {
      className: style.scrubber__bgBar,
      ref: bgElm => this.bgElm = bgElm
    }), h("div", {
      className: style.scrubber__bufferedBar
    }), h("div", {
      className: style.scrubber__playedBar,
      style: {
        width: `${position * 100}%`
      }
    }), h("button", {
      ref: handleElm => this.handleElm = handleElm,
      role: "slider",
      "aria-valuemin": "0",
      "aria-valuemax": duration * 1000,
      "aria-valuenow": time * 1000,
      style: {
        left: `${position * 100}%`
      }
    }));
  }

}

export default Scrubber;